module.exports = __webpack_public_path__ + "img/banner-company.077f78e5.jpg";